import React from "react";
import { Col, Row, Typography } from "antd";
import { BemHelper } from "../../utils";
import classNames from "classnames";

export type LabelFeatureProps = {
  children: React.ReactNode;
  label?: string;
  icon: React.ReactNode;
};

const bem = new BemHelper("label-feature");

export const LabelFeature: React.FC<LabelFeatureProps> = ({ children, icon, label }) => {
  return (
    <Row
      gutter={[6, 0]}
      className={classNames(bem.block(), label ? bem.modifier("has-label") : "")}
    >
      <Col
        className={classNames(bem.element("icon"), label ? bem.modifier("has-label", "icon") : "")}
      >
        {icon}
      </Col>
      <Col>
        <Row>
          {label && (
            <Col span={24}>
              <Typography.Text className={classNames(bem.element("label"))}>
                {label}
              </Typography.Text>
            </Col>
          )}
          <Col span={24}>
            <Typography.Text className={classNames(bem.element("value"))}>
              {children}
            </Typography.Text>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
